import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { default as dayjs } from 'dayjs'

export const FeeStatement = ({
  feeStatementData,
  applicationDetails,
  setFeeStatementId,
  setFeeStatement,
}) => {
  const [feeRs, setFeeRs] = React.useState(null)
  const [totalFee, setTotalFee] = React.useState(0)
  const getAcademicYears = () => {
    const academicYears =
      sessionStorage.getItem('auth') && JSON.parse(sessionStorage.getItem('auth'))
    return academicYears.state.dependeciesFormAPIS.academicYears
  }
  const getOnchangeAppl = (e) => {
    const filterAYSections = []
    feeStatementData.applicationAYClassSections.map((m) => {
      if (m.academicYearId === e) {
        filterAYSections.push(m)
      }
    })

    const feeReceipts = feeStatementData.feeReceipts.filter(
      (f) => f.applicationAYClassSectionId === filterAYSections[0]?.applicationAYClassSectionId,
    )
    setFeeRs(feeReceipts)
    const feeTotals = {
      total: filterAYSections[0]?.AY_TotalFee || 0,
      paid:
        _.sumBy(feeReceipts, function (o) {
          return o.feeAmount
        }) || 0,
      balance:
        filterAYSections[0]?.AY_TotalFee -
          _.sumBy(feeReceipts, function (o) {
            return o.feeAmount
          }) || 0,
    }

    setTotalFee(feeTotals)
    if (filterAYSections[0].AY_External_ScholarShips > 0) {
      setTotalFee({
        total: filterAYSections[0]?.AY_TotalFee || 0,
        paid:
          _.sumBy(feeReceipts, function (o) {
            return o.feeAmount
          }) || 0,
        balance:
          filterAYSections[0]?.AY_TotalFee -
            filterAYSections[0].AY_External_ScholarShips -
            _.sumBy(feeReceipts, function (o) {
              return o.feeAmount
            }) || 0,
        scholaship: {
          amount: filterAYSections[0].AY_External_ScholarShips,
          notes: filterAYSections[0].AY_External_ScholarshipsNotes,
        },
      })
    }
  }
  return (
    <div
      className="trtui-modal trtui-modal-xl trtui-fade trtui-show"
      aria-labelledby="exampleModalLabel"
      style={{ display: 'block', backgroundColor: 'rgba(55,55,55,0.3)' }}
      aria-modal="true"
      role="dialog"
    >
      <div className="trtui-modal-dialog trtui-modal-xl">
        <div className="trtui-modal-content">
          <div className="trtui-modal-header trtui-bg-light trtui-p-3">
            <h5 className="trtui-modal-title" id="exampleModalLabel">
              Fee Statement
            </h5>
            <button
              type="button"
              className="trtui-btn-close"
              onClick={() => {
                setFeeStatementId(null)
                setFeeStatement(false)
              }}
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i className="ri-close-line" />
            </button>
          </div>
          <div className="trtui-modal-body">
            <select
              className="trtui-form-control trtui-mb-2 trtui-mt-3"
              id="select-dd"
              name="class"
              onChange={(e) => {
                getOnchangeAppl(e.target.value)
              }}
            >
              <option title="S C">Select Academic Year</option>
              {getAcademicYears().formData.map((opt, optIndex) => (
                <option value={opt.academicYearId} key={optIndex}>
                  {opt.academicYearName}
                </option>
              ))}
            </select>
            <button
              id="print-button"
              type="button"
              onClick={() => window.print()}
              className="trtui-btn trtui-btn-primary trtui-mt-2 trtui-mb-2 trtui-py-1 trtui-font-16"
            >
              <i className="fa fa-print mr-2" />
              Print
            </button>
            <div className="trtui-table-responsive" id="report-to-print-fr">
              <table className="trtui-table trtui-table-bordered">
                <tbody>
                  <tr>
                    <td className="trtui-text-center" colSpan={5}>
                      <h3 style={{ textDecoration: 'underline' }}>School Fee Statement</h3>
                    </td>
                  </tr>
                  <tr>
                    <td className="trtui-mt-2" colSpan={4}>
                      <b>Student Name: {applicationDetails.studentName}</b>
                    </td>
                    <td className="trtui-mt-2" colSpan={3}>
                      <b>Total Fees: {totalFee.total?.toFixed(2) || 0}</b>
                    </td>
                  </tr>
                  <tr>
                    <td className="trtui-mt-2">Date</td>
                    <td className="trtui-mt-2">Type</td>
                    <td className="trtui-mt-2">Amount</td>
                    <td className="trtui-mt-2">Payment Mode</td>
                    <td className="trtui-mt-2">Paid By</td>
                  </tr>
                  {feeRs !== null &&
                    feeRs.map((data, dataIndex) => (
                      <tr key={dataIndex}>
                        <td className="trtui-mt-2">
                          {dayjs(data.feeReceivedDate).format('DD-MM-YYYY')}
                        </td>
                        <td className="trtui-mt-2">{data.feeType}</td>
                        <td className="trtui-mt-2">{data.feeAmount.toFixed(2)}</td>
                        <td className="trtui-mt-2">{data.paymentMethod}</td>
                        <td className="trtui-mt-2">{data.feeReceivedFrom}</td>
                      </tr>
                    ))}
                  <tr>
                    <td colSpan={2} className="trtui-mt-2">
                      <strong>Total Amount Paid</strong>
                    </td>
                    <td className="trtui-mt-2">
                      <strong>{totalFee.paid?.toFixed(2) || 0}</strong>
                    </td>
                    <td className="trtui-mt-2">
                      <strong>Balance {`${totalFee.scholaship ? 'After Scholarship' : ''}`}</strong>
                    </td>
                    <td className="trtui-mt-2">
                      <strong>{totalFee.balance?.toFixed(2) || 0}</strong>
                    </td>
                  </tr>
                  {totalFee.scholaship ? (
                    <tr>
                      <td colSpan={4} className="trtui-mt-2">
                        <strong>
                          Scholarship Details: {totalFee.scholaship.notes} -{' '}
                          {totalFee.scholaship.amount.toFixed(2)}
                        </strong>
                      </td>
                    </tr>
                  ) : null}
                  {feeRs !== null &&
                  feeRs.length &&
                  feeRs.length > 0 &&
                  feeRs[0].ApplicationAYClassSection?.AY_External_ScholarShips > 0 ? (
                    <tr>
                      <td colSpan={5}>
                        Scholarship Amount{' '}
                        {feeRs[0].ApplicationAYClassSection?.AY_External_ScholarShips.toFixed(2)}
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

FeeStatement.propTypes = {
  feeStatementData: PropTypes.array,
  applicationDetails: PropTypes.object,
  setFeeStatementId: PropTypes.func,
  setFeeStatement: PropTypes.func,
}
